<template>
  <div id="app">
    <h1>Vue 2 Yüz Algılama ve Zoom</h1>
    <FaceZoom />
  </div>
</template>

<script>
import FaceZoom from '@/components/FaceZoom.vue'

export default {
  name: 'App',
  components: {
    FaceZoom,
  },
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>